import { render, staticRenderFns } from "./InstallmentBatchTypeUpdate.vue?vue&type=template&id=3554aee0&"
import script from "./InstallmentBatchTypeUpdate.vue?vue&type=script&lang=js&"
export * from "./InstallmentBatchTypeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports